import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { StoreAuthService } from '@app/core/auth/store-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ListMediasService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private storeAuth: StoreAuthService,
  ) { }

  /**
   * ユーザーのメディア一覧を取得する。
   *
   * opts を省略した場合は従来どおり「最新 100 件」をまとめて返す
   * （レコード一覧・専門家ダイアログ等の共有キャッシュ用途）。
   *
   * opts を指定するとサーバー側 OFFSET/LIMIT ページングになる
   * （メディアギャラリーのページャ用途）。
   */
  listMedias(
    sectionId: string,
    userId: string,
    opts?: { count?: number; skip?: number; order?: 'asc' | 'desc' },
  ) {
    const user = this.msalService.instance.getActiveAccount();
    const loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    let params = new HttpParams()
      .set('givenTo', userId)
      .set('count', String(opts?.count ?? 100));

    if (opts?.skip != null) {
      params = params.set('skip', String(opts.skip));
    }
    if (opts?.order) {
      params = params.set('order', opts.order);
    }

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/medias`, { params, headers });
  }
}
